import classReducer from './';

export default classReducer;
